// Builders
import { buildEcommerceItems } from "./builders/buildEcommerceItems";

// Classes
import { ProductItem } from "./classes/ProductItem";
import { ProductTrackingData } from "./classes/ProductTrackingData";

function trackViewItem(
	products: any[],
	event: "view_item",
	packCode: string,
	averageRatingPerLihe: number,
	reviewNumberPerLihe: string
): void {
	console.log("FIRED");
	if (!event) throw new Error("eventName is mandatory in trackViewItem");
	const ecommerceObject: { ecommerce: { items: ProductItem[] } } | undefined =
		buildEcommerceItems(
			products,
			packCode,
			averageRatingPerLihe,
			reviewNumberPerLihe
		);

	if (!ecommerceObject) {
		throw new Error("no ecommerceObject built");
	}

	const trackingObject = new ProductTrackingData(ecommerceObject.ecommerce);

	// @ts-ignore
	window.dataLayer.push({
		event: trackingObject.event,
		ecommerce: ecommerceObject.ecommerce,
	});
}

export default trackViewItem;
